import React, { useContext, useState } from "react";
import IConnection_Token from "../../../models/IConnection_Token";
import INavItem from "../../../models/INavItem";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import * as _ from "lodash-es";
import UIService from "../../../services/UIService";
import OrderwerksGreyLogo from "../../../assets/images/orderwerks/orderwerks-logo-grey.svg";
import OrderwerksDarkLogo from "../../../assets/images/orderwerks/orderwerks-logo-dark.svg";
import { FormattedMessage } from "react-intl";
import OrderwerksLogo from "../../../assets/images/orderwerks/orderwerks-logo-grey.svg";
import SystemVersion from "../../shared/SystemVersion/SystemVersion";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { NavLink } from "react-router-dom";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import { SideNavLink } from "../../shared/SideNavLink/SideNavLink";
import "./HeaderFnMobile.scss";
import { OwThemeModeSwitcher } from "@components/shared/OwThemeModeSwitcher/OwThemeModeSwitcher";

type Props = {
    isSupplierUser: boolean;
    supplierUserToken?: IConnection_Token;
    vendorUserToken?: IConnection_Token;
    isOnline: boolean;
    routes: INavItem[];
    toggleHelpDock: () => void;
    doLogout: (event: any) => void;
    menuIconMode: boolean;
};

export const HeaderFnMobile = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const isHeaderLight = () => {
        const headerElem = document.getElementById("HeaderStandard");

        if (headerElem) {
            const bgColor = window.getComputedStyle(headerElem, null).getPropertyValue("background-color");

            const colorMatch = bgColor.match(/(\d+),\s*(\d+),\s*(\d+)/);

            // console.log("colorMatch", colorMatch);

            if (colorMatch) {
                const r = Number(colorMatch[1]);
                const g = Number(colorMatch[2]);
                const b = Number(colorMatch[3]);

                const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

                // console.log("isHeaderLight", hsp);
                if (hsp > 127.5) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    };

    // const getSupplierLogo = () => {
    let supplierLogo = false;
    let supplierLogoUrl = "";

    if (supplierModel.has_white_label && supplierModel.white_label_image_attachment_id) {
        supplierLogo = true;

        const { themeType } = UIService.getThemeType(supplierModel, userModel);

        if (themeType === "LIGHT") {
            supplierLogoUrl = _.get(supplierModel, "White_Label_Light_Image.signedUrl", "");
        } else {
            supplierLogoUrl = _.get(supplierModel, "White_Label_Image.signedUrl", "");
        }
    }
    // }

    let OrderwerksLogo = OrderwerksGreyLogo;

    if (isHeaderLight()) {
        OrderwerksLogo = OrderwerksDarkLogo;
    }

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const navigated = () => {
        if (mobileMenuOpen) {
            setMobileMenuOpen(false);
        }
    };

    // console.log("props.routes: ", props.routes);

    const navLiItems = (props.routes || []).map((navItem, index) => {
        return (
            <SideNavLink
                key={index}
                user={userModel}
                isSupplierUser={props.isSupplierUser}
                supplierUserToken={props.supplierUserToken}
                vendorUserToken={props.vendorUserToken}
                navItem={navItem}
                navigated={navigated}
                menuIconMode={props.menuIconMode}
            />
        );
    });

    const toggleMobileMenu = (event: any) => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <div className={"HeaderFnMobile"}>
            <header id={"HeaderMobile"} className="HeaderMobile d-flex flex-column d-md-none d-print-none">
                <div
                    className={"top-section col-12 d-flex justify-content-between align-items-center align-items-center mt-1"}
                    style={{
                        height: "100%",
                        flex: "1 1",
                    }}>
                    <div className="w-100 justify-content-between d-flex ps-2 pe-2">
                        {!UIService.isLoginPath() ? (
                            <label
                                tabIndex={0}
                                onClick={toggleMobileMenu}
                                className="d-inline-flex flex-column align-items-center header-icon me-3 mt-2">
                                <i className={"fas fa-bars " + (mobileMenuOpen ? "d-none" : "")} />
                                <i className={"fas fa-times " + (mobileMenuOpen ? "" : "d-none")} />
                                <div>
                                    <FormattedMessage id="app.menu" defaultMessage="Menu" description="Menu" />
                                </div>
                            </label>
                        ) : null}
                        <div className="d-flex flex-column ms-auto">
                            <div>
                                {!supplierLogo ? (
                                    <img alt="Orderwerks Logo" src={OrderwerksLogo} title={"Orderwerks"} className={"img-fluid"} />
                                ) : (
                                    <img
                                        alt={"Orderwerks B2B Sales Order Entry"}
                                        src={supplierLogoUrl}
                                        className={"img-fluid mobile-white-label-logo"}
                                    />
                                )}
                            </div>
                            <SystemVersion />
                        </div>
                    </div>
                </div>

                <div className={mobileMenuOpen ? "col-12 d-flex flex-column mobile-side-bar-nav-wrapper" : "d-none"}>
                    {props.isOnline ? null : (
                        <div className={"text-danger mt-3"}>
                            <OwLabel title={"offline"} leftIconClass={"fas fa-wifi-slash"} />
                        </div>
                    )}

                    <ul title={"Side Nav"} className={"list-unstyled sideBarNav " + (props.isOnline ? "" : "")}>
                        {navLiItems}
                        {!UIService.isLoginPath() ? (
                            <div>
                                <NavLink to="/profile">
                                    <li className="white-four header-icon" title={"Profile"}>
                                        <i className="fad fa-user-circle me-2" />
                                        <OwTranslate defaultMessage={"Profile"} id={`app.profile`} />
                                    </li>
                                </NavLink>

                                <hr className={"m-0 p-0 mt-2 mb-2"} />

                                <li className="white-four header-icon">
                                    <a onClick={props.toggleHelpDock} title={"Help"}>
                                        <i className="fad fa-question-circle me-2" />
                                        <OwTranslate defaultMessage={"Help"} id={"app.help"} />
                                    </a>
                                </li>

                                <li className="white-four header-icon" onClick={props.doLogout} title={"Logout"}>
                                    <i className="fad fa-sign-out me-2" />
                                    <OwTranslate defaultMessage={"Logout"} id={`app.logout`} />
                                </li>
                            </div>
                        ) : null}

                        <div className="mt-4">
                            <OwThemeModeSwitcher />
                        </div>

                        {supplierLogo ? (
                            <li className={"poweredByLogo"}>
                                <OwLabel title={"powered_by"} noBottomMargin={true} />
                                <img src={OrderwerksLogo} title={"Orderwerks"} />
                            </li>
                        ) : null}
                    </ul>
                </div>
            </header>
        </div>
    );
};
